module.exports = __webpack_public_path__ + "img/ALL互動英語.c9806e21.png";